import { useEffect, useState } from "react";
import { Download } from "lucide-react";

/**
 * Listens for the browser's `beforeinstallprompt` event and renders an
 * "Install app" button when the PWA is installable. Hidden on iOS Safari
 * (which doesn't fire the event — users add via the share sheet).
 */
export default function InstallAppButton({ className = "", testid = "install-pwa-btn" }) {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferred(null);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    // Detect existing standalone mode (already installed)
    if (window.matchMedia?.("(display-mode: standalone)").matches) {
      setInstalled(true);
    }
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || !deferred) return null;

  const onClick = async () => {
    deferred.prompt();
    try {
      await deferred.userChoice;
    } catch {
      /* user dismissed */
    }
    setDeferred(null);
  };

  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className={`flex items-center gap-1.5 text-sm transition-colors ${className}`}
    >
      <Download size={14} /> Install app
    </button>
  );
}
